const enableCondition = process.env.NEXT_PUBLIC_ANALYTICS_ENABLE !== 'false';

const checkAnalyticsFunction = <T extends (...args: any[]) => void>(fn: T) => {
  if (!enableCondition) return () => {};
  return fn;
};

const checkAnalyticsFunctionMap = <T extends Record<keyof T, (...args: any[]) => void>>(functions: T) =>
  Object.keys(functions).reduce(
    (acc, name) => Object.assign(acc, { [name]: checkAnalyticsFunction(functions[name as keyof T]) }),
    {} as Partial<T>,
  ) as T;

export default checkAnalyticsFunctionMap;
